/* eslint-disable */
import { DocumentTypeDecoration } from '@graphql-typed-document-node/core'
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K]
}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>
}
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>
}
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never }
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never
    }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
}

export type Context = {
  scope: Scope
}

export type InbentaKmSearchItem = {
  __typename?: 'InbentaKmSearchItem'
  categories?: Maybe<Array<Maybe<Scalars['Int']['output']>>>
  creationDate: Scalars['String']['output']
  hasCrossSelling: Scalars['Boolean']['output']
  hasDecisionTree: Scalars['Boolean']['output']
  hasRelated: Scalars['Boolean']['output']
  id: Scalars['Int']['output']
  modificationDate?: Maybe<Scalars['String']['output']>
  score: Scalars['Float']['output']
  slug: Scalars['String']['output']
  title: Scalars['String']['output']
  tracking: InbentaSearchItemTracking
}

export type InbentaKmSearchResponse = {
  __typename?: 'InbentaKmSearchResponse'
  error?: Maybe<SearchError>
  result?: Maybe<InbentaKmSearchResult>
}

export type InbentaKmSearchResult = {
  __typename?: 'InbentaKmSearchResult'
  items?: Maybe<Array<Maybe<InbentaKmSearchItem>>>
  total: Scalars['Int']['output']
  tracking: InbentaKmSearchTracking
}

export type InbentaKmSearchTracking = {
  __typename?: 'InbentaKmSearchTracking'
  searchCode: Scalars['String']['output']
  searchCrossSellingCode: Scalars['String']['output']
  searchRateCode: Scalars['String']['output']
}

export enum InbentaKmTrackingType {
  AutocompleterClick = 'autocompleter_click',
  Click = 'click',
  ExternalClick = 'external_click',
  InstantClick = 'instant_click',
  Rate = 'rate',
  SearchRate = 'search_rate',
}

export type InbentaSearchItem = {
  __typename?: 'InbentaSearchItem'
  category: InbentaSearchResultCategory
  contentId?: Maybe<Scalars['String']['output']>
  creationDate: Scalars['String']['output']
  highlightedTitle: Scalars['String']['output']
  image?: Maybe<Scalars['String']['output']>
  modificationDate?: Maybe<Scalars['String']['output']>
  productCategory?: Maybe<Scalars['String']['output']>
  score?: Maybe<Scalars['Int']['output']>
  title: Scalars['String']['output']
  tracking: InbentaSearchItemTracking
  url: Scalars['String']['output']
}

export type InbentaSearchItemTracking = {
  __typename?: 'InbentaSearchItemTracking'
  clickCode: Scalars['String']['output']
  externalCode: Scalars['String']['output']
  rateCode: Scalars['String']['output']
}

export type InbentaSearchOptions = {
  category: InbentaSearchResultCategory
  limit: Scalars['Int']['input']
  type?: InputMaybe<InbentaSearchType>
}

export type InbentaSearchResponse = {
  __typename?: 'InbentaSearchResponse'
  error?: Maybe<SearchError>
  result?: Maybe<Array<Maybe<InbentaSearchResult>>>
}

export type InbentaSearchResult = {
  __typename?: 'InbentaSearchResult'
  category: InbentaSearchResultCategory
  items?: Maybe<Array<Maybe<InbentaSearchItem>>>
  total: Scalars['Int']['output']
  tracking?: Maybe<InbentaSearchTracking>
}

export enum InbentaSearchResultCategory {
  Blog = 'BLOG',
  Faq = 'FAQ',
  Product = 'PRODUCT',
}

export type InbentaSearchTracking = {
  __typename?: 'InbentaSearchTracking'
  searchCode: Scalars['String']['output']
  searchRateCode: Scalars['String']['output']
}

export enum InbentaSearchType {
  Contact = 'contact',
  Instant = 'instant',
  Search = 'search',
}

export type InbentaTrackingResult = {
  __typename?: 'InbentaTrackingResult'
  success: Scalars['Boolean']['output']
}

export type InbentaTrackingSession = {
  __typename?: 'InbentaTrackingSession'
  sessionId: Scalars['String']['output']
  sessionToken: Scalars['String']['output']
}

export type MarketSearchItem = {
  __typename?: 'MarketSearchItem'
  codeIsin: Scalars['String']['output']
  currency?: Maybe<Scalars['String']['output']>
  label: Scalars['String']['output']
  mnemo: Scalars['String']['output']
  reference: Scalars['String']['output']
  stockExchange: Scalars['String']['output']
  type: Scalars['String']['output']
  url: Scalars['String']['output']
  value?: Maybe<Scalars['Float']['output']>
  variation?: Maybe<Scalars['Float']['output']>
}

export type MarketSearchOptions = {
  limit: Scalars['Int']['input']
}

export type MarketSearchResponse = {
  __typename?: 'MarketSearchResponse'
  error?: Maybe<SearchError>
  result?: Maybe<MarketSearchResult>
}

export type MarketSearchResult = {
  __typename?: 'MarketSearchResult'
  items?: Maybe<Array<Maybe<MarketSearchItem>>>
  total: Scalars['Int']['output']
}

export type Mutation = {
  __typename?: 'Mutation'
  sendKmTrackingEvents: InbentaTrackingResult
  sendSearchTrackingEvents: InbentaTrackingResult
}

export type MutationSendKmTrackingEventsArgs = {
  event: Scalars['String']['input']
  sessionToken: Scalars['String']['input']
  source?: InputMaybe<Scalars['String']['input']>
}

export type MutationSendSearchTrackingEventsArgs = {
  event: Scalars['String']['input']
  sessionToken: Scalars['String']['input']
  source?: InputMaybe<Scalars['String']['input']>
}

export type Query = {
  __typename?: 'Query'
  getFederatedSearches: InbentaSearchResponse
  getKmSearch: InbentaKmSearchResponse
  getKmTrackingSession?: Maybe<InbentaTrackingSession>
  getMarketSearch: MarketSearchResponse
  getSearchTrackingSession?: Maybe<InbentaTrackingSession>
}

export type QueryGetFederatedSearchesArgs = {
  context: Context
  options: Array<InputMaybe<InbentaSearchOptions>>
  query: Scalars['String']['input']
  sessionToken: Scalars['String']['input']
  source?: InputMaybe<Scalars['String']['input']>
}

export type QueryGetKmSearchArgs = {
  categoryId?: InputMaybe<Scalars['String']['input']>
  context: Context
  length: Scalars['Int']['input']
  query: Scalars['String']['input']
  sessionToken: Scalars['String']['input']
  source?: InputMaybe<Scalars['String']['input']>
  splitQuery?: InputMaybe<Scalars['Boolean']['input']>
  tracking?: InputMaybe<Scalars['Boolean']['input']>
  type?: InputMaybe<InbentaSearchType>
}

export type QueryGetMarketSearchArgs = {
  context: Context
  options: MarketSearchOptions
  query: Scalars['String']['input']
  source?: InputMaybe<Scalars['String']['input']>
}

export type Schema = {
  __typename?: 'Schema'
  mutation?: Maybe<Mutation>
  query?: Maybe<Query>
}

export enum Scope {
  Client = 'CLIENT',
  Prospect = 'PROSPECT',
}

export type SearchError = {
  __typename?: 'SearchError'
  message: Scalars['String']['output']
  status?: Maybe<Scalars['Int']['output']>
  statusText?: Maybe<Scalars['String']['output']>
}

export type FetchFaqSearchResultsQueryVariables = Exact<{
  query: Scalars['String']['input']
  searchSessionToken: Scalars['String']['input']
}>

export type FetchFaqSearchResultsQuery = {
  __typename?: 'Query'
  inbentaResponse: {
    __typename: 'InbentaSearchResponse'
    result?: Array<{
      __typename: 'InbentaSearchResult'
      category: InbentaSearchResultCategory
      total: number
      items?: Array<
        | ({ __typename?: 'InbentaSearchItem' } & {
            ' $fragmentRefs'?: {
              SearchResultsFaqItemFragment: SearchResultsFaqItemFragment
            }
          })
        | null
      > | null
      tracking?: {
        __typename?: 'InbentaSearchTracking'
        searchCode: string
      } | null
    } | null> | null
    error?:
      | ({ __typename?: 'SearchError' } & {
          ' $fragmentRefs'?: {
            SearchErrorFieldFragment: SearchErrorFieldFragment
          }
        })
      | null
  }
}

export type BlogRowFragment = {
  __typename: 'InbentaSearchItem'
  title: string
  url: string
  tracking: {
    __typename?: 'InbentaSearchItemTracking'
    clickCode: string
    externalCode: string
    rateCode: string
  }
} & { ' $fragmentName'?: 'BlogRowFragment' }

export type FaqRowFragment = {
  __typename: 'InbentaSearchItem'
  title: string
  url: string
  tracking: {
    __typename?: 'InbentaSearchItemTracking'
    clickCode: string
    rateCode: string
    externalCode: string
  }
} & { ' $fragmentName'?: 'FaqRowFragment' }

export type MarketRowFragment = {
  __typename: 'MarketSearchItem'
  codeIsin: string
  label: string
  stockExchange: string
  mnemo: string
  url: string
  variation?: number | null
  value?: number | null
  currency?: string | null
} & { ' $fragmentName'?: 'MarketRowFragment' }

export type ProductRowFragment = {
  __typename: 'InbentaSearchItem'
  title: string
  url: string
  tracking: {
    __typename?: 'InbentaSearchItemTracking'
    clickCode: string
    externalCode: string
    rateCode: string
  }
} & { ' $fragmentName'?: 'ProductRowFragment' }

export type FetchSplitSearchResultsQueryVariables = Exact<{
  query: Scalars['String']['input']
  searchSessionToken: Scalars['String']['input']
  includeMarketResponse: Scalars['Boolean']['input']
}>

export type FetchSplitSearchResultsQuery = {
  __typename?: 'Query'
  inbentaResponse?: {
    __typename: 'InbentaSearchResponse'
    result?: Array<{
      __typename: 'InbentaSearchResult'
      category: InbentaSearchResultCategory
      total: number
      items?: Array<
        | ({ __typename?: 'InbentaSearchItem' } & {
            ' $fragmentRefs'?: {
              SearchResultsProductItemFragment: SearchResultsProductItemFragment
              SearchResultsBlogItemFragment: SearchResultsBlogItemFragment
              SearchResultsFaqItemFragment: SearchResultsFaqItemFragment
            }
          })
        | null
      > | null
      tracking?: {
        __typename?: 'InbentaSearchTracking'
        searchCode: string
      } | null
    } | null> | null
    error?:
      | ({ __typename?: 'SearchError' } & {
          ' $fragmentRefs'?: {
            SearchErrorFieldFragment: SearchErrorFieldFragment
          }
        })
      | null
  }
  marketResponse?: {
    __typename: 'MarketSearchResponse'
    result?: {
      __typename: 'MarketSearchResult'
      total: number
      items?: Array<
        | ({ __typename?: 'MarketSearchItem' } & {
            ' $fragmentRefs'?: {
              SearchResultsMarketItemFragment: SearchResultsMarketItemFragment
            }
          })
        | null
      > | null
    } | null
    error?:
      | ({ __typename?: 'SearchError' } & {
          ' $fragmentRefs'?: {
            SearchErrorFieldFragment: SearchErrorFieldFragment
          }
        })
      | null
  }
}

export type FetchTrackingSessionQueryVariables = Exact<{ [key: string]: never }>

export type FetchTrackingSessionQuery = {
  __typename?: 'Query'
  search?: {
    __typename?: 'InbentaTrackingSession'
    sessionToken: string
    sessionId: string
  } | null
  km?: {
    __typename?: 'InbentaTrackingSession'
    sessionToken: string
    sessionId: string
  } | null
}

export type SearchResultsBlogItemFragment = {
  __typename: 'InbentaSearchItem'
  image?: string | null
  category: InbentaSearchResultCategory
  productCategory?: string | null
  title: string
  contentId?: string | null
  url: string
  tracking: {
    __typename?: 'InbentaSearchItemTracking'
    clickCode: string
    externalCode: string
    rateCode: string
  }
} & { ' $fragmentName'?: 'SearchResultsBlogItemFragment' }

export type SearchResultsFaqItemFragment = {
  __typename: 'InbentaSearchItem'
  title: string
  url: string
  tracking: {
    __typename?: 'InbentaSearchItemTracking'
    clickCode: string
    rateCode: string
    externalCode: string
  }
} & { ' $fragmentName'?: 'SearchResultsFaqItemFragment' }

export type SearchResultsMarketItemFragment = {
  __typename: 'MarketSearchItem'
  reference: string
  codeIsin: string
  label: string
  stockExchange: string
  mnemo: string
  type: string
  url: string
  variation?: number | null
  value?: number | null
  currency?: string | null
} & { ' $fragmentName'?: 'SearchResultsMarketItemFragment' }

export type SearchResultsProductItemFragment = {
  __typename: 'InbentaSearchItem'
  image?: string | null
  category: InbentaSearchResultCategory
  productCategory?: string | null
  title: string
  url: string
  tracking: {
    __typename?: 'InbentaSearchItemTracking'
    clickCode: string
    externalCode: string
    rateCode: string
  }
} & { ' $fragmentName'?: 'SearchResultsProductItemFragment' }

export type SearchErrorFieldFragment = {
  __typename: 'SearchError'
  status?: number | null
  statusText?: string | null
  message: string
} & { ' $fragmentName'?: 'SearchErrorFieldFragment' }

export type FetchSearchResultsQueryVariables = Exact<{
  query: Scalars['String']['input']
  searchSessionToken: Scalars['String']['input']
}>

export type FetchSearchResultsQuery = {
  __typename?: 'Query'
  inbentaResponse: {
    __typename: 'InbentaSearchResponse'
    result?: Array<{
      __typename: 'InbentaSearchResult'
      category: InbentaSearchResultCategory
      total: number
      items?: Array<
        | ({ __typename?: 'InbentaSearchItem' } & {
            ' $fragmentRefs'?: {
              SearchResultsProductItemFragment: SearchResultsProductItemFragment
              SearchResultsBlogItemFragment: SearchResultsBlogItemFragment
              SearchResultsFaqItemFragment: SearchResultsFaqItemFragment
            }
          })
        | null
      > | null
      tracking?: {
        __typename?: 'InbentaSearchTracking'
        searchCode: string
      } | null
    } | null> | null
    error?:
      | ({ __typename?: 'SearchError' } & {
          ' $fragmentRefs'?: {
            SearchErrorFieldFragment: SearchErrorFieldFragment
          }
        })
      | null
  }
  marketResponse: {
    __typename: 'MarketSearchResponse'
    result?: {
      __typename: 'MarketSearchResult'
      total: number
      items?: Array<
        | ({ __typename?: 'MarketSearchItem' } & {
            ' $fragmentRefs'?: {
              SearchResultsMarketItemFragment: SearchResultsMarketItemFragment
            }
          })
        | null
      > | null
    } | null
    error?:
      | ({ __typename?: 'SearchError' } & {
          ' $fragmentRefs'?: {
            SearchErrorFieldFragment: SearchErrorFieldFragment
          }
        })
      | null
  }
}

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: DocumentTypeDecoration<TResult, TVariables>['__apiType']
  private value: string
  public __meta__?: Record<string, any> | undefined

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value)
    this.value = value
    this.__meta__ = __meta__
  }

  toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value
  }
}
export const BlogRowFragmentDoc = new TypedDocumentString(
  `
    fragment BlogRow on InbentaSearchItem {
  __typename
  title
  tracking {
    clickCode
    externalCode
    rateCode
  }
  url
}
    `,
  { fragmentName: 'BlogRow' }
) as unknown as TypedDocumentString<BlogRowFragment, unknown>
export const FaqRowFragmentDoc = new TypedDocumentString(
  `
    fragment FaqRow on InbentaSearchItem {
  __typename
  title
  url
  tracking {
    clickCode
    rateCode
    externalCode
  }
}
    `,
  { fragmentName: 'FaqRow' }
) as unknown as TypedDocumentString<FaqRowFragment, unknown>
export const MarketRowFragmentDoc = new TypedDocumentString(
  `
    fragment MarketRow on MarketSearchItem {
  __typename
  codeIsin
  label
  stockExchange
  mnemo
  url
  variation
  value
  currency
}
    `,
  { fragmentName: 'MarketRow' }
) as unknown as TypedDocumentString<MarketRowFragment, unknown>
export const ProductRowFragmentDoc = new TypedDocumentString(
  `
    fragment ProductRow on InbentaSearchItem {
  __typename
  title
  tracking {
    clickCode
    externalCode
    rateCode
  }
  url
}
    `,
  { fragmentName: 'ProductRow' }
) as unknown as TypedDocumentString<ProductRowFragment, unknown>
export const SearchResultsBlogItemFragmentDoc = new TypedDocumentString(
  `
    fragment SearchResultsBlogItem on InbentaSearchItem {
  __typename
  image
  category
  productCategory
  title
  contentId
  tracking {
    clickCode
    externalCode
    rateCode
  }
  url
}
    `,
  { fragmentName: 'SearchResultsBlogItem' }
) as unknown as TypedDocumentString<SearchResultsBlogItemFragment, unknown>
export const SearchResultsFaqItemFragmentDoc = new TypedDocumentString(
  `
    fragment SearchResultsFaqItem on InbentaSearchItem {
  __typename
  title
  url
  tracking {
    clickCode
    rateCode
    externalCode
  }
}
    `,
  { fragmentName: 'SearchResultsFaqItem' }
) as unknown as TypedDocumentString<SearchResultsFaqItemFragment, unknown>
export const SearchResultsMarketItemFragmentDoc = new TypedDocumentString(
  `
    fragment SearchResultsMarketItem on MarketSearchItem {
  __typename
  reference
  codeIsin
  label
  stockExchange
  mnemo
  type
  url
  variation
  value
  currency
}
    `,
  { fragmentName: 'SearchResultsMarketItem' }
) as unknown as TypedDocumentString<SearchResultsMarketItemFragment, unknown>
export const SearchResultsProductItemFragmentDoc = new TypedDocumentString(
  `
    fragment SearchResultsProductItem on InbentaSearchItem {
  __typename
  image
  category
  productCategory
  title
  tracking {
    clickCode
    externalCode
    rateCode
  }
  url
}
    `,
  { fragmentName: 'SearchResultsProductItem' }
) as unknown as TypedDocumentString<SearchResultsProductItemFragment, unknown>
export const SearchErrorFieldFragmentDoc = new TypedDocumentString(
  `
    fragment SearchErrorField on SearchError {
  __typename
  status
  statusText
  message
}
    `,
  { fragmentName: 'SearchErrorField' }
) as unknown as TypedDocumentString<SearchErrorFieldFragment, unknown>
export const FetchFaqSearchResultsDocument = new TypedDocumentString(`
    query FetchFaqSearchResults($query: String!, $searchSessionToken: String!) {
  inbentaResponse: getFederatedSearches(
    context: {scope: PROSPECT}
    sessionToken: $searchSessionToken
    query: $query
    options: [{category: FAQ, limit: 100, type: search}]
    source: "web-faq"
  ) {
    __typename
    result {
      ... on InbentaSearchResult {
        __typename
        items {
          ...SearchResultsFaqItem
        }
        category
        total
        tracking {
          searchCode
        }
      }
    }
    error {
      ...SearchErrorField
    }
  }
}
    fragment SearchResultsFaqItem on InbentaSearchItem {
  __typename
  title
  url
  tracking {
    clickCode
    rateCode
    externalCode
  }
}
fragment SearchErrorField on SearchError {
  __typename
  status
  statusText
  message
}`) as unknown as TypedDocumentString<
  FetchFaqSearchResultsQuery,
  FetchFaqSearchResultsQueryVariables
>
export const FetchSplitSearchResultsDocument = new TypedDocumentString(`
    query FetchSplitSearchResults($query: String!, $searchSessionToken: String!, $includeMarketResponse: Boolean!) {
  inbentaResponse: getFederatedSearches(
    context: {scope: PROSPECT}
    sessionToken: $searchSessionToken
    query: $query
    options: [{category: PRODUCT, limit: 3, type: search}, {category: BLOG, limit: 3, type: search}, {category: FAQ, limit: 5, type: search}]
    source: "web-search"
  ) @skip(if: $includeMarketResponse) {
    __typename
    result {
      ... on InbentaSearchResult {
        __typename
        items {
          ...SearchResultsProductItem
          ...SearchResultsBlogItem
          ...SearchResultsFaqItem
        }
        category
        total
        tracking {
          searchCode
        }
      }
    }
    error {
      ...SearchErrorField
    }
  }
  marketResponse: getMarketSearch(
    context: {scope: PROSPECT}
    query: $query
    options: {limit: 5}
  ) @include(if: $includeMarketResponse) {
    __typename
    result {
      __typename
      items {
        ...SearchResultsMarketItem
      }
      total
    }
    error {
      ...SearchErrorField
    }
  }
}
    fragment SearchResultsBlogItem on InbentaSearchItem {
  __typename
  image
  category
  productCategory
  title
  contentId
  tracking {
    clickCode
    externalCode
    rateCode
  }
  url
}
fragment SearchResultsFaqItem on InbentaSearchItem {
  __typename
  title
  url
  tracking {
    clickCode
    rateCode
    externalCode
  }
}
fragment SearchResultsMarketItem on MarketSearchItem {
  __typename
  reference
  codeIsin
  label
  stockExchange
  mnemo
  type
  url
  variation
  value
  currency
}
fragment SearchResultsProductItem on InbentaSearchItem {
  __typename
  image
  category
  productCategory
  title
  tracking {
    clickCode
    externalCode
    rateCode
  }
  url
}
fragment SearchErrorField on SearchError {
  __typename
  status
  statusText
  message
}`) as unknown as TypedDocumentString<
  FetchSplitSearchResultsQuery,
  FetchSplitSearchResultsQueryVariables
>
export const FetchTrackingSessionDocument = new TypedDocumentString(`
    query FetchTrackingSession {
  search: getSearchTrackingSession {
    sessionToken
    sessionId
  }
  km: getKmTrackingSession {
    sessionToken
    sessionId
  }
}
    `) as unknown as TypedDocumentString<
  FetchTrackingSessionQuery,
  FetchTrackingSessionQueryVariables
>
export const FetchSearchResultsDocument = new TypedDocumentString(`
    query FetchSearchResults($query: String!, $searchSessionToken: String!) {
  inbentaResponse: getFederatedSearches(
    context: {scope: PROSPECT}
    sessionToken: $searchSessionToken
    query: $query
    options: [{category: PRODUCT, limit: 3, type: search}, {category: BLOG, limit: 3, type: search}, {category: FAQ, limit: 5, type: search}]
    source: "web-search"
  ) {
    __typename
    result {
      ... on InbentaSearchResult {
        __typename
        items {
          ...SearchResultsProductItem
          ...SearchResultsBlogItem
          ...SearchResultsFaqItem
        }
        category
        total
        tracking {
          searchCode
        }
      }
    }
    error {
      ...SearchErrorField
    }
  }
  marketResponse: getMarketSearch(
    context: {scope: PROSPECT}
    query: $query
    options: {limit: 5}
  ) {
    __typename
    result {
      __typename
      items {
        ...SearchResultsMarketItem
      }
      total
    }
    error {
      ...SearchErrorField
    }
  }
}
    fragment SearchResultsBlogItem on InbentaSearchItem {
  __typename
  image
  category
  productCategory
  title
  contentId
  tracking {
    clickCode
    externalCode
    rateCode
  }
  url
}
fragment SearchResultsFaqItem on InbentaSearchItem {
  __typename
  title
  url
  tracking {
    clickCode
    rateCode
    externalCode
  }
}
fragment SearchResultsMarketItem on MarketSearchItem {
  __typename
  reference
  codeIsin
  label
  stockExchange
  mnemo
  type
  url
  variation
  value
  currency
}
fragment SearchResultsProductItem on InbentaSearchItem {
  __typename
  image
  category
  productCategory
  title
  tracking {
    clickCode
    externalCode
    rateCode
  }
  url
}
fragment SearchErrorField on SearchError {
  __typename
  status
  statusText
  message
}`) as unknown as TypedDocumentString<
  FetchSearchResultsQuery,
  FetchSearchResultsQueryVariables
>
